
import moment, { max } from 'moment'
import "./dailyweatherItem.css"

import { useState } from 'react'
import { useEffect } from 'react'

const DailyWeatherItem =(props)=>{
  
    const [heatColor,setHeatColor] = useState("255,201,157")

    useEffect(()=>{
        handelColor()
    },[])

    const handelColor=()=>{
        var maxHeat = props.itemData.main.temp_max
         const dif = maxHeat-24
           
         setHeatColor(`${dif*dif*dif+40},${90-dif*4},${90-maxHeat*1.5}`) 
    }

    const t = props.t;

    return(
        <div className="dailyWeatherItemContainer" style={ {background:`linear-gradient(20deg, rgba(2,0,0,0) 10%, rgb(${heatColor}) 65%)`}}>
           <div className="dailyWeatherItemHeader">
             <p>{t(`${moment(props.itemData.dt_txt, "YYYY-MM-DD").format('dddd')}`)}</p> 
             <img alt="icone" src={`https://openweathermap.org/img/wn/${props.itemData.weather[0].icon}@2x.png`}/>
           </div>
           <div className="dailyWeatherItemBody">
               <p>{Math.floor(props.itemData.main.temp_max)}°C</p>
               
           </div>
           <div className="dailyWeatherItemsFooter">
               <div className="infoblock"> <img src="https://cdn-icons-png.flaticon.com/512/1165/1165011.png"/> <p>{Math.floor(props.itemData.wind.speed*3.6)}  </p></div>
               <div className="infoblock"><img src="https://static.thenounproject.com/png/3522470-200.png"/><p>{props.itemData.main.humidity}</p></div>
               
               </div>
        </div>      
    )
}

export default DailyWeatherItem ; 